import { useCallback, useEffect, useRef, useState } from "react";

export function useCountdown(): {
    secondsLeft: number;
    start: (seconds: number) => void;
} {
    const [secondsLeft, setSecondsLeft] = useState(0);
    const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);

    const clear = useCallback(() => {
        if (intervalRef.current !== null) {
            clearInterval(intervalRef.current);
            intervalRef.current = null;
        }
    }, []);

    const start = useCallback(
        (seconds: number) => {
            clear();
            setSecondsLeft(seconds);
            intervalRef.current = setInterval(() => {
                setSecondsLeft((prev) => {
                    if (prev <= 1) {
                        clear();
                        return 0;
                    }
                    return prev - 1;
                });
            }, 1_000);
        },
        [clear]
    );

    useEffect(() => clear, [clear]);

    return { secondsLeft, start };
}
